import { render } from "./greenEnergy.vue?vue&type=template&id=721e9538&scoped=true"
import script from "./greenEnergy.vue?vue&type=script&lang=js"
export * from "./greenEnergy.vue?vue&type=script&lang=js"

import "./greenEnergy.vue?vue&type=style&index=0&id=721e9538&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/huwei-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721e9538"]])

export default __exports__